import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2500347e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleCard: require('/home/focomotor-2/htdocs/focomotor.com.ar/components/Vehicle/Card.vue').default,VehicleIndexFilters: require('/home/focomotor-2/htdocs/focomotor.com.ar/components/Vehicle/index/Filters.vue').default,App: require('/home/focomotor-2/htdocs/focomotor.com.ar/components/App.vue').default})
